export default __webpack_public_path__ + "static/media/image-ph-health-home-m@2x.5541a61f.png";